export default __webpack_public_path__ + "static/media/availableRedemption.37dbb310.svg";